import { render, staticRenderFns } from "./VehicleOCR.vue?vue&type=template&id=d4ebb03e&scoped=true&"
import script from "./VehicleOCR.vue?vue&type=script&lang=js&"
export * from "./VehicleOCR.vue?vue&type=script&lang=js&"
import style0 from "./VehicleOCR.vue?vue&type=style&index=0&id=d4ebb03e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ebb03e",
  null
  
)

export default component.exports